import { render, staticRenderFns } from "./pages8.vue?vue&type=template&id=e96b61a0&"
import script from "./pages8.vue?vue&type=script&lang=js&"
export * from "./pages8.vue?vue&type=script&lang=js&"
import style0 from "./pages8.vue?vue&type=style&index=0&id=e96b61a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports